import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  currencies: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewCurrency: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateCurrency: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteCurrency: {
    data: {},
    isLoading: false,
    hasError: false,
  }  
};

export const currencyReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_CURRENCY:
      return {
        ...newState,
        currencies: { ...newState.currencies, isLoading: true, hasError: false },
      };
    case actionTypes.GET_CURRENCY_SUCCESS:
      return {
        ...newState,
        currencies: { ...newState.currencies, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_CURRENCY_FAILURE:
      return {
        ...newState,
        currencies: { ...newState.currencies, data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_CURRENCY:
      return {
        ...newState,
        createNewCurrency: { ...newState.createNewCurrency, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_CURRENCY_SUCCESS:
      return {
        ...newState,
        createNewCurrency: { ...newState.createNewCurrency, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_CURRENCY_FAILURE:
      return {
        ...newState,
        createNewCurrency: { ...newState.createNewCurrency, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_CURRENCY:
      return {
        ...newState,
        updateCurrency: { ...newState.updateCurrency, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_CURRENCY_SUCCESS:
      return {
        ...newState,
        updateCurrency: { ...newState.updateCurrency, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_CURRENCY_FAILURE:
      return {
        ...newState,
        updateCurrency: { ...newState.updateCurrency, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.DELETE_CURRENCY:
        return {
          ...newState,
          deleteCurrency: { ...newState.deleteCurrency, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_CURRENCY_SUCCESS:
        return {
          ...newState,
          deleteCurrency: { ...newState.deleteCurrency, data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_CURRENCY_FAILURE:
        return {
          ...newState,
          deleteCurrency: { ...newState.deleteCurrency, data: action.payload, isLoading: false, hasError: true },
        };

    default:
      return { ...newState };
  }
};
